import { api } from '@/components/Functional/lib/request'
import { logger } from '@/components/Functional/utils/logger'
import { MenuListResponseSchema } from '@/schemas/v2'
import type { MenuListResponse } from '@/schemas/v2'

const BASE = process.env.NEXT_PUBLIC_API_URL ?? ''

type FetchOptions = { headers?: Record<string, string> }

export async function fetchMenus(options?: FetchOptions): Promise<MenuListResponse> {
  const url = `${BASE}/api/v2/menus`
  logger.info({ fetch_method: 'GET', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.get<unknown>(url, options)
    return MenuListResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'GET', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}
